import React from "react";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { CircularProgress } from "@mui/material";

const useStyles = makeStyles(theme => ({
  root: {
    display: "table",
    width: "100%",
    height: "100%",
    backgroundColor: alpha(theme.palette.body, 0.7)
  },
  cell: {
    display: "table-cell",
    width: "100%",
    height: "100%",
    verticalAlign: "middle",
    textAlign: "center"
  }
}));

function CircularProgressOverlay(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.cell}>
        <CircularProgress color="primary" />
      </div>
    </div>
  );
}

export default CircularProgressOverlay;
